import FormBuilder from '../components/form-builder/FormBuilder';

export default function FormBuilderPage() {
  return <FormBuilder />;
}
